import request from '../utils/Request';
import { Methods } from '../config';
import { downloadFile } from '../utils/download';

const baseURL = 'formPrintTemplate';

const appendKeyIfPresent = (formData, key) => {
  if (key !== undefined && key !== null) {
    formData.append('key', key);
  }
};

const formPrintTemplateService = {
  getTemplates: () => {
    return request({
      resource: `${baseURL}/`,
    });
  },
  uploadFile: (file, id, userId, key) => {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('userId', userId);
    appendKeyIfPresent(formData, key);

    return request({
      method: Methods.POST,
      resource: `${baseURL}/uploadFile/${encodeURIComponent(id)}`,
      formData: true,
      data: formData,
    });
  },

  deleteFile: (id, userId, key) => {
    const data = { userId };

    if (key !== undefined && key !== null) {
      data.key = key;
    }

    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/deleteFile/${encodeURIComponent(id)}`,
      data,
    });
  },

  getFile: async (id, fileName) => {
    const file = await request({
      responseType: 'blob',
      resource: `${baseURL}/getFile/${encodeURIComponent(id)}`,
    });
    return downloadFile(file, fileName);
  },
};

export default formPrintTemplateService;
